<template>
  <div id="app">
    <Navbar></Navbar>
    <loader v-if="loaderShow"></loader>
    <div>
      <div v-if="step == 0">
        <div class="row justify-content-around mt-5 pt-5">
          <div class="col-sm-4 mt-2 card">
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Generic Model</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Create custom models or train new models on any time-series data, get forecasts, predictions.</p>
             <span style="color: blue; text-decoration: underline" @click="routeToautoML" class="cursor-pointer pl-3 pb-4 mt-auto">Get Started<i class="fa fa-arrow-circle-right ml-2" aria-hidden="true"></i></span>
          </div>
          <div class="col-sm-4 mt-2 card">
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Exploratory Data Analysis (EDA)</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Upload data, select variables and analyze and generate report with one click. Download and share the generated report.</p>
            <span style="color: blue; text-decoration: underline" @click="routeToVisualize" class="cursor-pointer  pl-3 pb-4 mt-auto">Get Started<i class="fa fa-arrow-circle-right ml-2" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swal from 'sweetalert2';
// import Toasted from 'vue-toasted';
// import Vue from 'vue';
import $ from "jquery";
// import moment from "moment";
// import { AUTH_LOGOUT } from '../store/actions/auth'
// import "vue2-datepicker/index.css";
// import { apiCall } from '@/utils/api';
import loader from './loader';
import Navbar from './navbar';
// import axios from 'axios';
// import multiselect from 'vue-multiselect';
// import Table from './Table';

// Vue.use(Toasted);

export default {
  name: "Dashboard",
  props: {
    msg: String,
  },
  components: {
    loader: loader,
    Navbar: Navbar,
    // multiselect: multiselect,
    // Table: Table
  },
  data() {
    return {
      mName: '',
      fillTypes: {"forward fill": "ffill", "backward fill": "bfill"},
      fillType: "ffill",
      frequencyType: {"1 Hour": "H", "15 minutes": "15min", "Daily": "D"},
      frequency: 'H',
      file:"",
      message:"",
      step: 0,
      loaderShow: false,
      childRows: {},
      selectedPolutant: [],
      modelTrainPollutant: ["CO", "NO2", "PM10", "PM25", "SO2", "OZONE"],
      from: "",
      to: "",
      checked: false,
      uploadFileDetails: {},
      datetime_column: "",
      lastTraining: [],
      modelInfo: {},
      fileName: '',
    };
  },
  watch: {
    checked: function(val) {
      if (val) {
        this.selectedPolutant = this.modelTrainPollutant;
      } else {
        this.selectedPolutant = [];
      }
    }
  },
  mounted() {
    $(".multiselect__select").attr("style", "height: 34px !important");
    $(".multiselect__placeholder").attr(
      "style",
      "margin-bottom: 3px !important; padding-top: 0px !important; color: #555 !important"
    );
    $(".multiselect__tags").attr(
      "style",
      "min-height: 34px !important;color: #555 !important; font-size: 14px !important; padding-top: 6px !important; padding-left: 10px !important; line-height: 1.4 !important; padding-bottom: 6px !important"
    );
  },
  computed: {
  },
  methods: {
    routeToautoML() {
      this.$router.push('/automl')
    },
    routeToVisualize() {
      this.$router.push('/visualize')
    },
    // giveNameToModel() {
    //   if (this.mName === '' || this.mName === ' ') {
    //     this.$toasted.show('please give model name', { duration: 1000 })
    //     return
    //   }
    //   const url = `auto_ml`
    //   this.loaderShow = true
    //   const body = {
    //     name: this.mName
    //   }
    //   apiCall({ url, data: body, method: 'post' }).then((resp) => {
    //     this.modelInfo = resp.data
    //     this.step = 3;
    //     this.loaderShow = false
    //   }).catch((err) => {
    //     this.loaderShow = false
    //   })
    // },
    // update() {
    //   this.step = 2
    // },
    // callIntervalApi () {
    //   // const ths = this
    //   // setInterval(function(){
    //   //    ths.updateProcess()
    //   // }, 10000);
    // },
    // updateProcess () {
    //   const url = 'auto_ml'
    //   apiCall({ url, method: 'get' }).then((resp) => {
    //   }).catch((err) => {
    //   })
    // },
    // downloadData () {},
    // triggerTrain () {},
    // preProcess() {
    //   this.loaderShow = true
    //   if (this.datetime_column === '' || this.datetime_column === ' ') {
    //     this.$toasted.show('please fill input', { duration: 1000 })
    //     this.loaderShow = false
    //     return
    //   }
    //   const fileName = this.uploadFileDetails.Key.split('/')
    //   const body = {
    //     raw_file_url: this.uploadFileDetails.Location,
    //     raw_bucket_name : 'ambee-forecast-auto-train',
    //     raw_file_name: fileName[1],
    //     numerical_features: this.selectedPolutant,
    //     datetime_column: this.datetime_column,
    //     fr: this.frequency,
    //     method: this.fillType
    //   }
    //   const url = `auto_ml/${this.modelInfo._id}/preprocess`
    //   apiCall({ url, data: body, method: 'put' }).then((resp) => {
    //     this.step = 4;
    //     this.loaderShow = false
    //     Swal.fire({
    //         title: 'Please Wait',
    //         text: `pre-processing started it will take time`,
    //         type: 'success',
    //         showCancelButton: false,
    //         confirmButtonColor: '#3085d6',
    //         confirmButtonText: 'continue to dashboard',
    //       }).then((result) => {
    //         if (result.value) {
    //           this.step = 1
    //         }
    //       })
    //   }).catch((err) => {
    //     this.loaderShow = false
    //   })
    // },
    // onSelect(){
    //   const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    //   const file = this.$refs.file.files[0];
    //   this.file = file;
    //   this.fileName = this.$refs.file.files[0].name
    //   if(!allowedTypes.includes(file.type)){
    //     this.message = "Filetype is wrong!!"
    //   }
    //   if(file.size>500000){
    //     this.message = 'Too large, max size allowed is 500kb'
    //   }
    // },
    // async onSubmit(){
    //   this.loaderShow = true
    //   const formData = new FormData();
    //   formData.append('file',this.file);
    //   try{
    //     const token = localStorage.getItem('user-token') || '';
    //     if (token) { axios.defaults.headers.common.Authorization = `Bearer ${token}`; }
    //     await axios.put(`https://automl-api.getambee.com/upload/${this.modelInfo._id}/${this.modelInfo.name}`,formData).then((r) => {
    //       this.modelTrainPollutant = r.data.keys
    //       this.uploadFileDetails = r.data.data
    //       this.step = 4
    //       this.loaderShow = false
    //     })
    //   }
    //   catch(err){
    //   }
    // },
    // uploadFile () {
    //   var file = this.$refs.docsUpload.files[0]
    //   const token = localStorage.getItem('user-token') || '';
    //   var ths = this
    //   if (token) { axios.defaults.headers.common.Authorization = `Bearer ${token}`; }
    //   axios.post('http://13.233.166.48:3001/upload/uploadFIle/v2', file)
    //   .then(function(response) {
    //     ths.step = 3
    //     ths.uploadFileDetails = response.data.data
    //   })
    //   .catch(function(err) {
    //   })
    // },
    // logout() {
    //   this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    // },
    // getTime(thingkey, pollutantName) {
    //   let currentTime = this.rows.filter(row => {
    //     return row.thingKey === thingkey;
    //   })[0];
    //   return moment(currentTime[pollutantName].startedAt).format(
    //     "DD-MM-YY HH:mm:ss"
    //   );
    // },
    // toggle(id) {
    //   // this.$router.push(`/Device`)
    //   const index = this.opened.indexOf(id);
    //   if (index > -1) {
    //     this.opened.splice(index, 1);
    //   } else {
    //     this.opened.push(id);
    //   }
    // }
  },
  created() {
    var intval = setInterval(() => {
      if (this.percentage < 100) this.percentage += 0.1;
      else clearInterval(intval);
    }, 10);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.downloadButton {
  width: 20rem;
  height: 5rem;
}
.selectC{
    background: white;
    border: 1px solid #e8e8e8;
    color: #555 ;
    border-radius: 6px;
    min-height: 34px ;
    font-size: 14px ;
    padding-top: 6px ;
    padding-left: 10px ;
    line-height: 1.4 ;
    padding-bottom: 6px ;
}
.inputSty {
    min-height: 34px ;
    color: #555 ;
    font-size: 14px ;
    padding-top: 6px ;
    padding-left: 10px ;
    line-height: 1.4 ;
    padding-bottom: 6px ;
    width: 86%;
    padding-left: 12px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
}
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
.multi {
  /* z-index: 99; */
  height: auto;
  width: 80% !important;
}

.details {
  color: white;
}
/*custom font*/

/* @primary-color: #63a2cb; */
/* @#67d5bf: #67d5bf; */
/*basic reset*/
* {
  margin: 0;
  padding: 0;
}

html {
  height: 100%;
  background: #0e0e0e;
}

body {
  font-family: "Open Sans", arial, verdana;
}
/*headings*/
.fs-title {
  font-size: 16px;
  text-transform: uppercase;
  color: #63a2cb;
  margin-bottom: 10px;
}
.fs-subtitle {
  font-weight: normal;
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.help-block {
  font-size: 0.8em;
  color: #7c7c7c;
  text-align: left;
  margin-bottom: 0.5em;
}
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

select {
  height: 34px !important;
  width: 80% !important;
}


a.button {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  padding: 0;
  margin: 10px 20px 10px 0;
  font-weight: 600;
  text-align: center;
  line-height: 50px;
  color: #fff;
  border-radius: 5px;
  transition: all 0.2s;
}

a,
a:visited {
  text-decoration: none;
  color: white !important;
}
.button {
    width: 6rem;
    height: 3rem;
    /* margin: 1rem; */
    border: 1px solid blue;
    color: white;
    background: cadetblue;
    /* padding: 1rem; */
    border-radius: 20px;
}
.button_outer {background: #83ccd3; border-radius:30px; text-align: center; height: 50px; width: 200px; display: inline-block; transition: .2s; position: relative; overflow: hidden;}
.btn_upload {padding: 17px 30px 12px; color: #fff; text-align: center; position: relative; display: inline-block; overflow: hidden; z-index: 3; white-space: nowrap;}
.inputClass {position: absolute; width: 100%; left: 0; top: 0; width: 100%; height: 105%; cursor: pointer; opacity: 0;}
</style>
